import { CssBaseline } from '@mui/material';
import LogRocket from 'logrocket';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './app';
import AppTheme from './app-theme';
import { store } from './features/store.redux';
import './index.css';
import ConfigService from './services/config.service';

// LogRocket
LogRocket.init(ConfigService.appConfig.logRocketId, {
    network: {
        requestSanitizer: (request) => {
            // Do not log bearer token
            if (request.headers.Authorization) {
                request.headers.Authorization = request.headers.Authorization.replace(/Bearer\s.+/, 'Bearer [REDACTED]');
            }
            return request;
        }
    }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <AppTheme>
        <CssBaseline />

        <Provider store={store}>
            <App />
        </Provider>
    </AppTheme>
);

document.querySelector('#root');

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
